module.exports = __webpack_public_path__ + "media/images/emblems/WappenAltdorf2016-ba9d68cead644bf0b594f9f84517507b.svg";